import {Mail, Home, Circle, Image, Copy, FileText, User, Settings, File, Compass} from 'react-feather'
import {getUserData} from "../../utility/Utils";
// eslint-disable-next-line no-duplicate-imports
import {Cpu, Airplay, Coffee} from 'react-feather'

let navigationItems = [
    {
        id: 'natjecanja',
        title: 'Natjecanja',
        icon: <Mail size={20}/>,
        navLink: '/natjecanja',
        roles: ["super admin", "admin", "delegate", "operative", "team admin", "team leader"]
    },
    {
        id: 'upravljanje',
        title: 'Upravljanje',
        icon: <Cpu size={20}/>,
        roles: ["admin", "super admin", "team admin", "technician"],
        children: [
            {
                id: 'sastavnice',
                title: 'Sastavnice',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/sastavnice',
                roles: ["admin", "super admin"],
            },
            {
                id: 'organisations',
                title: 'Organizacije',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/organizacije',
                roles: ["super admin"],
            },
            {
                id: 'seasons',
                title: 'Sezone',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/sezone',
                roles: ["super admin"],
            },
            {
                id: 'roles',
                title: 'Roles',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/roles',
                roles: ["admin", "super admin", "team admin"],
            },
            {
                id: 'korisnici',
                title: 'Korisnici',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/korisnici',
                roles: ["admin", "super admin", "technician", "team admin"],
            },
            {
                id: 'sportovi-rekreacija',
                title: 'Sportovi rekreacija',
                icon: <Circle size={12}/>,
                navLink: '/upravljanje/sportovi-rekreacije',
                roles: ["super admin"],
            }
        ]
    },
    {
        id: 'rekreacije',
        title: "Rekreacije",
        icon: <Airplay size={20}/>,
        navLink: '/rekreacije',
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']

    },
    {
        id: 'objave',
        title: 'Objave',
        icon: <Coffee size={20}/>,
        navLink: '/objave',
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"]
    },
    {
        id: "galerija",
        title: "Galerija",
        icon: <Image size={20}/>,
        navLink: "/galerija",
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        id: "dokumenti",
        title: "Dokumenti",
        icon: <File size={20}/>,
        navLink: "/dokumenti",
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        id: "stranice",
        title: "Stranice",
        icon: <Copy size={20}/>,
        navLink: "/stranice",
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
    {
        id: "cms-postavke",
        title: "CMS postavke",
        icon: <Settings size={20}/>,
        navLink: "/cms-postavke",
        roles: ["super admin", "CMS admin", "CMS editor", "CMS author"],
    },
  /*  {
        id: "moje-statistike",
        title: "Moje statistike",
        icon: <Compass size={20}/>,
        navLink: "/moje-statistike",
        roles: ["user"],
    },
    {
        id: "statistike-sastavnice",
        title: "Statistike sastavnice",
        icon: <Compass size={20}/>,
        navLink: "/statistike-sastavnice",
        roles: ["team admin", "team leader"],
    },*/
    {
        id: "moji-dokumenti",
        title: "Moj status",
        icon: <FileText size={20}/>,
        navLink: "/moji-dokumenti",
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
    {
        id: "korisnički-profil",
        title: "Korisnički profil",
        icon: <User size={20}/>,
        navLink: "/korisnicki-profil",
        roles: ['super admin', 'admin', 'technician', 'delegate', 'operative', 'team admin', 'team leader', 'player', 'user', 'student']
    },
]

export default navigationItems;
